import * as actionTypes from "../../actions/actionTypes";

const initialState = {
  allBlocked: [],
  total: 1,
};

const blockedPatients = (state = initialState, action) => {
  switch (action.type) {
    case actionTypes.ALL_BLOCKED_PATIENTS:
      return {
        ...state,
        allBlocked: [...action.results],
        total: action.total,
      };
    case actionTypes.EMPTY_BLOCKED_PATIENTS:
      return {
        ...state,
        allBlocked: [],
        total: 1,
      };
    default:
      return state;
  }
};

export default blockedPatients;
